<template>
  <div class="NetworkCmp">
    <slot name="network">
    </slot>
  </div>
</template>
<script type="text/javascript">
  export default {
    name: "NetworkCmp",
  };
</script>
